export function normalizeFilters<T extends Record<string, any>>(filters?: T) {
  if (!filters) return {}

  const out: Record<string, unknown> = {}

  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined) continue

    if (typeof v === 'string') {
      const s = v.trim()
      if (s === '') continue // treat empty string as "no filter"
      out[k] = s
      continue
    }

    out[k] = v
  }

  return out
}